var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M200-.5H0v200h26.099c2.885-35.293 24.07-64.381 52.419-74.319C64.372 117.596 54.75 102.674 54.75 85.5c0-24.853 20.146-45 45-45 24.853 0 45 20.147 45 45 0 17.095-9.533 31.963-23.572 39.58 28.5 9.837 49.828 39.002 52.724 74.42H200V-.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M121.178 125.08c14.039-7.617 23.572-22.485 23.572-39.58 0-24.853-20.147-45-45-45-24.854 0-45 20.147-45 45 0 17.174 9.622 32.096 23.768 39.681-28.349 9.938-49.534 39.026-52.419 74.319h147.803c-2.896-35.418-24.224-64.583-52.724-74.42z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.bdbef8ff3d50dc405c1d674609f61b07.svg";
export { ForwardRef as ReactComponent };